function setElHeightVariables() {

	function setViewportHeight() {
		// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
		let vh = window.innerHeight * 0.01;
		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty('--vh', vh + 'px');
	}
	setViewportHeight();

	function setHeaderHeight() {
		const header = document.querySelector('#header');
		const modalHeader = document.querySelector('#map-header');
		// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
		let headerHeight = header.offsetHeight;
		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty('--headerHeight', headerHeight + 'px');
	}
	setHeaderHeight();

	function setFooterHeight() {
		// First we get the viewport height and we multiply it by 1% to get a value for a vh unit
		let footerHeight = document.querySelector('#site-footer').offsetHeight;

		// Then we set the value in the --vh custom property to the root of the document
		document.documentElement.style.setProperty('--footerHeight', footerHeight + 'px');
	} 
	setFooterHeight();

	function update() {
		var timeout
			
		// If there's a timer, cancel it
		if (timeout) {
			window.cancelAnimationFrame(timeout);
		}

		// Setup the new requestAnimationFrame()
		timeout = window.requestAnimationFrame(function () {
			// We execute the same script as before
			setViewportHeight();
			setHeaderHeight();
			setFooterHeight();
			console.log('setElHeightVariables.js updated');
		});	
	}

	// Debounce
	function debounce(func, time){
		var time = time || 100; // 100 by default if no param
		var timer;
		return function(event){
				if(timer) clearTimeout(timer);
				timer = setTimeout(func, time, event);
		};
	}

	// Wait until innerheight changes, for max 120 frames
	function orientationChanged() {
		const timeout = 120;
		return new window.Promise(function(resolve) {
			const go = (i, height0) => {
				window.innerHeight != height0 || i >= timeout ?
					resolve() :
					window.requestAnimationFrame(() => go(i + 1, height0));
			};
			go(0, window.innerHeight);
		});
	}

	// Listen to the resize event if not a touch device
	if (! document.body.classList.contains("is-mobile")) {
		window.addEventListener("resize", () => {
			debounce(update());
		}, false);
	};

	// listen to the orientationchange event if a touch device
	if (document.body.classList.contains("is-mobile")) {
		window.addEventListener("orientationchange", () => {
			orientationChanged().then(function() {
				update();
			});
		}, true);
	};

};

export default setElHeightVariables;